import {IStatusIconProps} from 'components/ui/Icon/StatusIcons/IStatusIconProps';

const WarningIcon = (props: IStatusIconProps) => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <circle cx="10" cy="10" r="10" fill="#FFBF1D" />
            <path
                d="M9 6.2C9 5.53726 9.53726 5 10.2 5C10.8627 5 11.4 5.53726 11.4 6.2V11.2074C11.4 11.8701 10.8627 12.4074 10.2 12.4074C9.53726 12.4074 9 11.8701 9 11.2074V6.2Z"
                fill="white"
            />
            <circle cx="10.2" cy="14.6" r="1.2" fill="white" />
        </svg>
    );
};

export default WarningIcon;
